import { render, staticRenderFns } from "./AboutDirectory.vue?vue&type=template&id=2536d3f4&"
import script from "./AboutDirectory.vue?vue&type=script&lang=js&"
export * from "./AboutDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports